import logs from '@/services/apiCalls/logs'
import store from '@/store/store'

export default async (err) => {
  try {
    const { data } = await logs.putLog(err, store.state.nextSequenceToken);
    store.commit('setNextSequenceToken', data.putLogEvents.nextSequenceToken);
  } catch (e) {
    return Promise.reject(e);
  }
};
